import { IStyle } from "@fluentui/react";

export const noWrapStyle: IStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};